export const formatBorrowerObjectFullName = (borrower) => {
  if (!borrower) return "N/A";

  return `${borrower?.firstName || ""} ${borrower?.lastName || ""}`.trim();
};
